import AddSon from "views/parent/AddSon.js";
import Son from "views/parent/Son.js";
import RankingCharts from "views/parent/RankingCharts.js";
import BigGoalSettingedit from "views/parent/BigGoalSettingedit.js";
import GoalSettingedit from "views/parent/GoalSettingedit.js";

import DiaryChart from "views/diary/DiaryChart.js";
import DiaryList from "views/diary/DiaryList.js";
import DiaryChart3 from "views/diary/DiaryChart3.js";
import DiaryList3 from "views/diary/DiaryList3.js";
import DiaryChart4 from "views/diary/DiaryChart4.js";
import DiaryList4 from "views/diary/DiaryList4.js";
import DiaryChart5 from "views/diary/DiaryChart5.js";
import DiaryList5 from "views/diary/DiaryList5.js";
import DiaryChart6 from "views/diary/DiaryChart6.js";
import DiaryList6 from "views/diary/DiaryList6.js";
import DiaryChart7 from "views/diary/DiaryChart7.js";
import DiaryList7 from "views/diary/DiaryList7.js";
import DiaryChart8 from "views/diary/DiaryChart8.js";
import DiaryList8 from "views/diary/DiaryList8.js";

import DiaryChart9 from "views/diary/DiaryChart9.js";
import DiaryList9 from "views/diary/DiaryList9.js";
import DiaryChart10 from "views/diary/DiaryChart10.js";
import DiaryList10 from "views/diary/DiaryList10.js";
import DiaryChart11 from "views/diary/DiaryChart11.js";

import Preparationedit from "views/parent/Preparationedit.js";
import Tablesedit from "views/parent/Tablesedit.js";

var noSidebarParentRoutes = [ 
  {
    path: "/addSon",
    name: "子供を追加",
    icon: "nc-icon nc-share-66",
    component: AddSon,
    layout: "/parent",
  },
  {
    path: "/son",
    name: "子供を追加",
    icon: "nc-icon nc-share-66",
    component: Son,
    layout: "/parent",
  },    
  {
    path: "/rankingChart",
    name: "ランキング",
    icon: "nc-icon nc-bullet-list-67",
    component: RankingCharts,
    layout: "/parent",
  },
  {
    path: "/biggoalsettingedit",
    name: "大会目標編集",
    icon: "nc-icon nc-share-66",
    component: BigGoalSettingedit,
    layout: "/parent",
  },
  {
    path: "/goalsettingedit",
    name: "課題目標設定編集",
    icon: "nc-icon nc-bullet-list-67",
    component: GoalSettingedit,
    layout: "/parent",
  },
  {
    path: "/diaryChart",
    name: "日記チャート",
    icon: "nc-icon nc-share-66",
    component: DiaryChart,
    layout: "/parent",
  },
  {
    path: "/diaryList",
    name: "日記リスト",
    icon: "nc-icon nc-share-66",
    component: DiaryList,
    layout: "/parent",
  },
  {
    path: "/diaryChart3",
    name: "日記チャート",
    icon: "nc-icon nc-share-66",
    component: DiaryChart3,
    layout: "/parent",
  },
  {
    path: "/diaryList3",
    name: "日記チャート",
    icon: "nc-icon nc-share-66",
    component: DiaryList3,
    layout: "/parent",
  },
  {
    path: "/diaryChart4",
    name: "日記チャート",
    icon: "nc-icon nc-share-66",
    component: DiaryChart4,
    layout: "/parent",
  },
  {
    path: "/diaryList4",
    name: "日記チャート",
    icon: "nc-icon nc-share-66",
    component: DiaryList4,
    layout: "/parent",
  },
  {
    path: "/diaryChart5",
    name: "日記チャート",
    icon: "nc-icon nc-share-66",
    component: DiaryChart5,
    layout: "/parent",
  },
  {
    path: "/diaryList5",
    name: "日記チャート",
    icon: "nc-icon nc-share-66",
    component: DiaryList5,
    layout: "/parent",
  },
  {
    path: "/diaryChart6",
    name: "日記チャート",
    icon: "nc-icon nc-share-66",
    component: DiaryChart6,
    layout: "/parent",
  },
  {
    path: "/diaryList6",
    name: "日記チャート",
    icon: "nc-icon nc-share-66",
    component: DiaryList6,
    layout: "/parent",
  },
  {
    path: "/diaryChart7",
    name: "日記チャート",
    icon: "nc-icon nc-share-66",
    component: DiaryChart7,
    layout: "/parent",
  },
  {
    path: "/diaryList7",
    name: "日記チャート",
    icon: "nc-icon nc-share-66",
    component: DiaryList7,
    layout: "/parent",
  },
  {
    path: "/diaryChart8",
    name: "日記チャート",
    icon: "nc-icon nc-share-66",
    component: DiaryChart8,
    layout: "/parent",
  },
  {
    path: "/diaryList8",
    name: "日記チャート",
    icon: "nc-icon nc-share-66",
    component: DiaryList8,
    layout: "/parent",
  },
  {
    path: "/diaryChart9",
    name: "日記チャート",
    icon: "nc-icon nc-share-66",
    component: DiaryChart9,
    layout: "/parent",
  },
  {
    path: "/diaryList9",
    name: "日記チャート",
    icon: "nc-icon nc-share-66",
    component: DiaryList9,
    layout: "/parent",
  },
  {
    path: "/diaryChart10",
    name: "日記チャート",
    icon: "nc-icon nc-share-66",
    component: DiaryChart10,
    layout: "/parent",
  },
  {
    path: "/diaryList10",
    name: "日記チャート",
    icon: "nc-icon nc-share-66",
    component: DiaryList10,
    layout: "/parent",
  },
  {
    path: "/diaryChart11",
    name: "日記チャート",
    icon: "nc-icon nc-share-66",
    component: DiaryChart11,
    layout: "/parent",
  },  
  {
    path: "/preparationedit",
    name: "試合準備編集",
    icon: "nc-icon nc-bullet-list-67",
    component: Preparationedit,
    layout: "/parent",
  }, 
  {
    path: "/tablesedit",
    name: "試合後リフレクション編集",
    icon: "nc-icon nc-bullet-list-67",
    component: Tablesedit,
    layout: "/parent",
  },    
];

export default noSidebarParentRoutes;